import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextareaComponent } from "../../templates/template-textarea/template-textarea.component";
import { MaxLength } from "../../types/MaxLength";

@Component({
  selector: "app-prefix-bs3",
  imports: [TemplateTextareaComponent],
  templateUrl: "./prefix-bs3.component.html",
  styleUrl: "./prefix-bs3.component.less",
})
export class PrefixBs3Component extends PrefixTextComponent {
  public maxlength: MaxLength;

  public constructor() {
    super();
    this.maxlength = 100;
    this.characters = ALLOWED_CHARACTERS["bs3"];
  }
}
